import { render, staticRenderFns } from "./VueDataTableIconMenu.vue?vue&type=template&id=bacb40e6&scoped=true"
import script from "./VueDataTableIconMenu.vue?vue&type=script&lang=js"
export * from "./VueDataTableIconMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacb40e6",
  null
  
)

export default component.exports